import moment from 'moment'

let Validator = {}

Validator.CheckDate = (dateString) => {
    const dateFormat = 'DD/MM/YYYY';

    const UI_DATE_FORMAT = 'DD/MM/YYYY';
    const SERVER_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

    const UI_DATE = moment(dateString, UI_DATE_FORMAT, true);
    const SERVER_DATE = moment(dateString, SERVER_DATE_FORMAT, true);


    if (dateString === null || dateString === undefined || dateString === "") {
        return false;
    } else {
        return UI_DATE.isValid() || SERVER_DATE.isValid();
    }
}

Validator.CheckValidWeight = (weight, unit, minWeightLbs, maxWeightLbs, allowMin) => {
    
    if (unit === 'Lbs') {
        return allowMin ? 
            (weight < maxWeightLbs && weight >= minWeightLbs)
            : (weight < maxWeightLbs && weight > minWeightLbs);
    } else if (unit === 'Kgs') {
        return allowMin ?
            (weight < (maxWeightLbs / 2.204) && weight >= (minWeightLbs / 2.204))
            : (weight < (maxWeightLbs / 2.204) && weight > (minWeightLbs / 2.204));
    }
};

Validator.CheckValidWeightNoMetrics = (weight, minWeightLbs, maxWeightDisplay, allowMin) => {
    return allowMin ?
        (weight < maxWeightDisplay && weight >= minWeightLbs)
        : (weight < maxWeightDisplay && weight > minWeightLbs);
};

export default Validator;